import React, { Component } from 'react'
import get from 'lodash/get'
import PropTypes from 'prop-types'
import { Field, reduxForm } from 'redux-form'
import { TextField, SelectField } from '../../components'
import { Alert, Button, Col, Row, SubmitRow } from '../../elements'

import validate from './validate'

class SingleReaderForm extends Component {
    static propTypes = {
        onSubmit: PropTypes.func,
    }

    render() {
        const { isSubmiting, handleSubmit, onSubmit, clients, initialValues } = this.props
        const clientIdDisabled = Boolean(get(initialValues, 'clientId'))
        const siteIdDisabled = Boolean(get(initialValues, 'siteId'))
        const readerSnDisabled = Boolean(get(initialValues, 'readerSn'))
        const agentIdDisabled = Boolean(get(initialValues, 'agentId'))
        let clientIds = null
        if(clients){
            clientIds = clients.map(client => client.clientId);
        } else if (initialValues) {
            clientIds = [initialValues.clientId]
        }

        if(clientIds == null){
            clientIds = ['']
        }

        return (
            <form onSubmit={handleSubmit(onSubmit)}>
                <Field
                    name="clientId"
                    label="Client Id"
                    options={clientIds}
                    component={SelectField}
                    disabled={clientIdDisabled}
                />
                <Field
                    name="siteId"
                    label="Site Id"
                    component={TextField}
                    disabled={siteIdDisabled}
                />
                <Field
                    name="readerSn"
                    label="Reader Sn"
                    component={TextField}
                    disabled={readerSnDisabled}
                />
                <Field
                    name="agentId"
                    label="Agent Id"
                    component={TextField}
                    disabled={agentIdDisabled}
                />
                <Field
                    name="endpoint"
                    label="Endpoint"
                    disabled={isSubmiting}
                    component={TextField}
                />
                <SubmitRow>
                    <Row type="flex" gutter={20}>
                        <Col>
                            <Button htmlType="submit" type="primary" wide>
                                {siteIdDisabled ? 'Save' : 'Create'}
                            </Button>
                        </Col>
                    </Row>
                </SubmitRow>
            </form>
        )
    }
}

export default reduxForm({
    form: 'single-reader-form',
    validate,
})(SingleReaderForm)



// WEBPACK FOOTER //
// ./src/smart-components/single-reader-form/index.js